import get from "lodash/fp/get";
import pick from "lodash/fp/pick";
import { IGroupQuery } from "~/lib/queries/__generated__/GroupQuery.generated";
import { IGroupInput, IGroupKind } from "~/types/types";

export function convertValuesToVariables(values: any): IGroupInput {
  const products = values.products.filter((product: any) => product._id).map(get("_id"));
  const outsideProducts = values.products.filter((product: any) => product.id);

  return {
    logo: values.logo,
    name: values.name,
    about: values.about,
    vendor: null,
    website: values.website || "",
    newsworthy: (values.newsworthy || []).map((newsworthy: any) => {
      return {
        url: newsworthy.url,
        description: newsworthy.description,
        title: newsworthy.title,
        favicon: newsworthy.favicon,
        siteName: newsworthy.siteName,
      };
    }),
    products,
    outsideProducts: (outsideProducts || []).map((outsideProduct: any) => {
      if (outsideProduct.id.startsWith("@")) {
        return {
          name: outsideProduct.name,
          url: outsideProduct.url,
        };
      }

      return {
        _id: outsideProduct.id,
        name: outsideProduct.name,
        url: outsideProduct.url,
      };
    }),
    resources: values.resources.map(pick(["type", "url", "title", "body"])),
    socialMedia: pick(["facebook", "instagram", "linkedin", "twitter", "youtube"], values.socialMedia) || null,
    visibility: values.visibility,
    location: values.location,
    members: values.members || [],
    tags: (values.tags || []).map(({ _id, objectID }: any) => _id || objectID) || [],
    awards: (values.awards || []).map(({ _id, objectID }: any) => _id || objectID),
    kind: IGroupKind.Vendor,
  };
}

export function convertGroupToInitialValues(group: NonNullable<IGroupQuery["groupBySlug"]>) {
  const products = (group.products || []).map(pick(["_id", "name", "logo"]));
  const outsideProducts = (group.outsideProducts || []).map((outsideProduct) => {
    return {
      id: outsideProduct._id,
      name: outsideProduct.name,
      url: outsideProduct.url,
    };
  });

  return {
    logo: group.logo,
    name: group.name,
    location: group.location,
    about: group.about,
    website: group.website,
    newsworthy: (group.newsworthy || []).map((newsworthy) => {
      return {
        url: newsworthy.url,
        description: newsworthy.description,
        title: newsworthy.title,
        favicon: newsworthy.favicon,
        siteName: newsworthy.siteName,
      };
    }),
    products: [...products, ...outsideProducts].map(addObjectId),
    resources: group.resources,
    socialMedia: group.socialMedia,
    visibility: group.visibility,
    awards: group.awards,
    tags: group.tags || [],
  };
}

const addObjectId = (entity: any) => ({
  ...entity,
  objectID: entity._id,
});
